import React from 'react';
import PropTypes from 'prop-types';
import TransitionMotionModal from 'transitionmotion-modal';
import logo from '../assets/images/Localvore_horizontal_2c.png';
import styled from 'styled-components';

const Code = styled.h1`
  border: 2px dashed #d23823;
  display: inline-block;
  margin: 15px auto 15px auto;
  padding: 1rem;
`;

const ValueProp = styled.h2`
  margin-bottom: 30px;
`;

const InputAddon = styled.div`
  background: #ccc;
  color: #444;
`;

const Restrictions = styled.ul`
  margin-bottom: 1rem !important;
  margin-left: 18px;
`;

const Errors = styled.li`
  color: red;
`;

export default class AuthHeaderVouchers extends React.Component {
  state = {
    errors: [],
    redeeming: null,
    total: 0,
    voucher: ''
  }

  newBill = deal => {
    let total = 0;
    if (this.state.total > 0) {
      total = this.state.total - deal.value;
      if (total < 0) total = 0;
      return total.toFixed(2);
    }
    return total.toFixed(2);
  }

  onChange = (property, e) => {
    this.setState({ [property]: e.target.value, errors: [] });
  }

  redeem = () => {
    this.props._merchant.redeemVoucher(this.state.redeeming.id, this.state.total)
      .then(res => this.setState({ redeeming: null, voucher: '' }))
      .catch(err => this.setState({ redeeming: null, voucher: '', errors: ['Something went wrong, please try again or contact support'] }));
  }

  search = () => {
    if (this.state.voucher === '') {
      this.setState({ errors: ['Please provide a voucher code'] });
      return false;
    }

    this.props._merchant.searchVoucher(this.state.voucher)
      .then(res => res.data.attributes.status === 'available' ? this.setState({ redeeming: res.data }) : this.setState({ errors: ['<p><strong>That code has already been redeemed</strong></p>'] }))
      .catch(err => this.setState({ errors: ['<p>Deal not found</p><p>Some older codes used a font that makes it difficult to distinguish between numbers and letters, especially "O" vs. "0 (Zero)".  Please make sure you\'ve entered the correct characters.</p>'] }));
  }

  render() {
    const { entities } = this.props;

    let deal;
    if (this.state.redeeming) {
      deal = entities.get('deals').get(this.state.redeeming.attributes.deal_id);
    }

    return <TransitionMotionModal
        customClass="fullscreen Vouchers"
        customClose={true}
        show={this.props.show}
        toggle={this.props.toggle}
        outerStyle={{zIndex: 202, position: 'relative'}}
      >
        <div className="fixed-top">
          <div className="container">
            <div className="row">
              <div className="col-12 text-right p-half-gutter">
                <img src={logo} className="img-fluid" style={{maxWidth: '250px', float: 'left', marginTop: '-15px'}} alt=""/>

                <div
                  onClick={this.props.toggle}
                >
                  <i className="fa fa-2x icon-lv-cancel" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content mt-5">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-9 col-lg-6 pt-5 pb-3 mx-auto">
                <h1 className="text-center">Redeem Deal{!this.state.redeeming && 's'}</h1>
              </div>
            </div>
          </div>

          {!this.state.redeeming && <div className="container">
              <div className="row">
                <div className="col-12 col-md-9 col-lg-6 mx-auto pb-5">
                  <label htmlFor="voucher">Voucher Code:</label>
                  <input type="text"
                    style={{padding: '.75rem'}}
                    name="voucher"
                    value={this.state.voucher}
                    onChange={this.onChange.bind(this, 'voucher')}
                    className="form-control"
                    />
                  <ul>
                    {this.state.errors.map((e, i) => <Errors key={i} dangerouslySetInnerHTML={{ __html: e }}></Errors>)}
                  </ul>
                </div>
              </div>
          </div>}
          {this.state.redeeming && 
            deal && 
              <div className="container">
            <div className="row">
              <div className="col-12 col-md-9 col-lg-7 mx-auto pb-5 text-center">
                <Code>{this.state.redeeming.id}</Code>
                <ValueProp>Pay ${deal.paid} for ${deal.value}</ValueProp>

                <Restrictions>
                  {deal.restrictions.map((r, j) => <li key={j}>{r}</li>)}
                </Restrictions>

                <div className="form-group text-left">
                  <label htmlFor="total">Total Bill: {this.state.errors.length > 0 && <span style={{ color: 'red' }}>{this.state.errors[0]}</span>}</label>
                  <div className="input-group">
                    <InputAddon className="input-group-addon">$</InputAddon>
                    <input
                      placeholder="Enter Bill Total"
                      className="form-control"
                      type="text"
                      name="total"
                      value={this.state.total}
                      onChange={this.onChange.bind(this, 'total')}
                    />
                  </div>
                </div>
                <p>Discount: ${deal.value.toFixed(2)}</p>
                <p>New Bill: ${this.newBill(deal)}</p>
              </div>
            </div>
          </div>}
        </div>
        <div className="post-submit-container container">
          <div className="row no-gutters">
            <div className="col-12 col-md-9 col-lg-7 mx-auto text-center pb-5">
              {!this.state.redeeming && <button className="btn btn-primary btn-lg" onClick={this.search}>Find Voucher</button>}
              {this.state.redeeming && <button className="btn btn-primary btn-lg" onClick={this.redeem}>Redeem Deal</button>}
            </div>
          </div>
        </div>
      </TransitionMotionModal>;
  }
}

AuthHeaderVouchers.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/AuthHeaderVouchers.js